import * as React from "react";
import styled from "styled-components";
import { IconButtonsRow } from "../../../../classes/IconButtonsRow";
import { colors } from "../../../../vars/palette";
import BlockIconCopyButton from "./BlockIconCopyButton";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #332237;
  padding: 3rem 0 2rem;
  h2 {
    font-weight: 600;
    color: ${colors.hex("secondary")};
  }
  p {
    color: white;
    margin: 1rem 1rem 2rem;
    text-align: center;

  }
`;
const ButtonsWrap = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0 10vw;
  @media only screen and (max-width: 640px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BlockIconButtonsRow = ({
  block,
  currSol,
}: {
  block: IconButtonsRow;
  currSol?: string;
}) => {
  const { headline, buttons, subtitle } = block;
  buttons.sort((a, b) => a.title.localeCompare(b.title));
  return (
    <Wrap>
      {headline ? <h2>{headline}</h2> : null}
      {subtitle ? <p>{subtitle}</p> : null}
      <ButtonsWrap>
        {buttons?.map((button, i) =>
          !currSol ? ( // solutions page and any pages that are not individual solutions pages will not have a currSol
            <BlockIconCopyButton block={button} key={`iconCopyButton-${i}`} />
          ) : (
            // for the individual solutions pages, only render buttons that do not match the current solution
            !currSol.toLowerCase().includes(button.title.toLowerCase()) && (
              <BlockIconCopyButton block={button} key={`iconCopyButton-${i}`} />
            )
          )
        )}
      </ButtonsWrap>
    </Wrap>
  );
};

export default BlockIconButtonsRow;
